import React from 'react';
import { Link } from 'react-router-dom';

const SECTIONS = [
    'Загальні положення',
    'Реєстрація та обліковий запис',
    'Контент та інтелектуальна власність',
    'Заборонений контент',
    'Монетизація та подарунки',
    'Обмеження відповідальності',
    'Зміни умов та припинення дії',
    'Застосовне право',
];

export default function TermsContentUk() {
    return (
        <div className="lp-content">
            {/* ── Table of contents ── */}
            <nav className="lp-toc" aria-label="Зміст">
                <p className="lp-toc-title">Зміст</p>
                <ol className="lp-toc-list">
                    {SECTIONS.map((title, i) => (
                        <li key={i}>
                            <a href={`#s${i + 1}`} className="lp-toc-link">
                                <span className="lp-toc-num">{i + 1}.</span>
                                {title}
                            </a>
                        </li>
                    ))}
                </ol>
            </nav>

            <div className="lp-highlight">
                <strong>Коротко:</strong> Knitly — це відкрита платформа для музикантів. Використовуючи сервіс, ви погоджуєтесь із цими умовами та берете на себе відповідальність за контент, який публікуєте.
            </div>

            {/* 1 */}
            <section id="s1" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">1</span>
                    <h2 className="lp-section-title">Загальні положення</h2>
                </div>
                <p>
                    Ці Умови використання («Умови») регулюють доступ та використання веб-сайту <strong>knitly.app</strong> та всіх пов'язаних сервісів (надалі — «Платформа»), що надаються Knitly.
                </p>
                <p>
                    Отримуючи доступ до Платформи або використовуючи її, ви підтверджуєте, що прочитали, зрозуміли та погоджуєтесь дотримуватись цих Умов. Якщо ви не погоджуєтесь з будь-яким положенням, вам необхідно негайно припинити використання Платформи.
                </p>
                <p>
                    Використання Платформи особами віком до 13 років заборонено. Особи від 13 до 18 років можуть використовувати Платформу лише за наявності дозволу батьків або законних опікунів.
                </p>
            </section>

            {/* 2 */}
            <section id="s2" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">2</span>
                    <h2 className="lp-section-title">Реєстрація та обліковий запис</h2>
                </div>
                <p>
                    Для отримання повного доступу до функцій Платформи необхідна реєстрація. Ви зобов'язуєтесь:
                </p>
                <ul>
                    <li>Надавати достовірні та актуальні дані при реєстрації.</li>
                    <li>Зберігати конфіденційність облікових даних та паролю.</li>
                    <li>Негайно повідомляти Knitly про будь-який несанкціонований доступ до вашого облікового запису.</li>
                    <li>Нести відповідальність за всі дії, здійснені з вашого облікового запису.</li>
                </ul>
                <p>
                    Knitly залишає за собою право призупинити або видалити обліковий запис без попередження у разі порушення цих Умов.
                </p>
                <div className="lp-info">
                    Ми рекомендуємо увімкнути двофакторну автентифікацію (2FA) у налаштуваннях облікового запису для підвищення безпеки.
                </div>
            </section>

            {/* 3 */}
            <section id="s3" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">3</span>
                    <h2 className="lp-section-title">Контент та інтелектуальна власність (UGC Disclaimer)</h2>
                </div>
                <p>
                    Увесь контент завантажується користувачами (User Generated Content). Knitly не перевіряє його заздалегідь і не несе відповідальності за порушення. Публікуючи будь-який контент на Платформі (музику, тексти, зображення, відео), ви підтверджуєте та гарантуєте, що:
                </p>
                <ul>
                    <li>Є єдиним власником або маєте всі необхідні ліцензії, права, дозволи на такий контент.</li>
                    <li>Контент не порушує авторські права, торговельні марки чи інші права третіх осіб.</li>
                    <li>Контент не порушує чинне законодавство України та міжнародні норми.</li>
                </ul>
                <p>
                    Розміщуючи контент, ви надаєте Knitly невиключну, безоплатну, світову ліцензію на відтворення, розповсюдження та відображення такого контенту виключно з метою надання послуг Платформи.
                </p>
                <p>
                    <strong>Відшкодування (Indemnification):</strong> Якщо на Knitly подасть у суд третя сторона (наприклад, лейбл або артист) через трек чи інший контент, який завантажили ВИ, ви зобов'язані компенсувати нам усі юридичні та судові витрати.
                </p>
                <div className="lp-highlight">
                    Процедура подачі скарг щодо порушення авторських прав описана в нашій <Link to="/copyright">Політиці авторських прав та DMCA</Link>.
                </div>
            </section>

            {/* 4 */}
            <section id="s4" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">4</span>
                    <h2 className="lp-section-title">Заборонений контент та Модерація</h2>
                </div>
                <p>
                    Knitly залишає за собою право на власний розсуд видалити будь-який контент або заблокувати обліковий запис без пояснення причин та без попереднього повідомлення.
                </p>
                <p>На Платформі суворо забороняється:</p>
                <ul>
                    <li>Розміщення контенту, що порушує авторські права третіх осіб без дозволу правовласника.</li>
                    <li>Публікація матеріалів, що містять мову ненависті, дискримінацію або загрозу насильством.</li>
                    <li>Розповсюдження спаму, вірусів, шкідливого програмного забезпечення.</li>
                    <li>Пропаганда тероризму, екстремізму.</li>
                </ul>
            </section>

            {/* 5 */}
            <section id="s5" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">5</span>
                    <h2 className="lp-section-title">Монетизація та подарунки</h2>
                </div>
                <p>
                    Платформа може надавати можливості монетизації для авторів контенту, включаючи систему цифрових подарунків. Умови монетизації визначаються окремими угодами.
                </p>
                <p>
                    Всі транзакції здійснюються виключно через офіційні платіжні системи Платформи.
                </p>
            </section>

            {/* 6 */}
            <section id="s6" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">6</span>
                    <h2 className="lp-section-title">Обмеження відповідальності</h2>
                </div>
                <p>
                    Платформа надається «як є» без будь-яких гарантій щодо її доступності, безперебійної роботи або відповідності конкретним цілям. Knitly не несе відповідальності за:
                </p>
                <ul>
                    <li>Втрату даних або контенту внаслідок технічних збоїв.</li>
                    <li>Дії або контент третіх сторін (користувачів) на Платформі.</li>
                    <li>Непрямі, випадкові або послідовні збитки.</li>
                </ul>
            </section>

            {/* 7 */}
            <section id="s7" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">7</span>
                    <h2 className="lp-section-title">Зміни умов та припинення дії</h2>
                </div>
                <p>
                    Knitly залишає за собою право змінювати ці Умови в будь-який час. Продовження використання Платформи після набрання змінами чинності означає вашу згоду з оновленими Умовами.
                </p>
                <p>
                    Ви можете видалити обліковий запис у будь-який час через розділ Налаштування. Після видалення застосовуються правила нашої <Link to="/privacy">Політики конфіденційності</Link>.
                </p>
            </section>

            {/* 8 */}
            <section id="s8" className="lp-section">
                <div className="lp-section-header">
                    <span className="lp-section-num">8</span>
                    <h2 className="lp-section-title">Застосовне право</h2>
                </div>
                <p>
                    Ці Умови регулюються та тлумачаються відповідно до законодавства України. Всі спори, що виникають у зв'язку з використанням Платформи, підлягають вирішенню у судах України, якщо інше не передбачено обов'язковими нормами законодавства у країні вашого проживання.
                </p>
                <p>
                    Якщо ви є споживачем у країні Європейського Союзу, ви можете скористатись правами, наданими чинним законодавством вашої країни щодо захисту споживачів, у тому числі правом на звернення до місцевих судів.
                </p>
            </section>

            {/* Contact */}
            <div className="lp-contact-card">
                <h3>Питання щодо умов?</h3>
                <p>
                    Якщо у вас є питання щодо цих Умов, зв'яжіться з нами: <a href="mailto:legal@knitly.app">legal@knitly.app</a>
                </p>
            </div>
        </div>
    );
}
